// extracted by mini-css-extract-plugin
export default {"layout":"Contact_layout__8RzaF","map":"Contact_map__OpvYV"};